(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/registration.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/registration.js');

'use strict';

const {
  useDispatch
} = ReactRedux;
const {
  useHistory,
  useParams
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const {
  putParticipation
} = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  useCompetitionType
} = svs.components.marketplaceCompetition.services.hooks;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  preventDoubleClick
} = svs.components.lbUtils;
const {
  CompetitionType
} = svs.components.marketplaceCompetition.constants;
const {
  processErrorCode
} = svs.components.marketplaceShared.competitionErrorCodes;
const Registration = _ref => {
  let {
    competition
  } = _ref;
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const compType = useCompetitionType(competition.id);
  const compName = resolveCompetitionName(competition);
  const {
    tipsSmRulesDocumentId,
    tipsEmRulesDocumentId,
    policyPersonalData
  } = svs.tipsen.data.competition;
  const rulesDocumentId = compType === CompetitionType.TipsEM ? tipsEmRulesDocumentId : tipsSmRulesDocumentId;
  const initPutParticipation = async () => {
    try {
      await dispatch(putParticipation({
        competitionId: competition.id
      })).unwrap();
      svs.components.analytics.trackEvent({
        category: compType,
        action: 'joined competition',
        opt_label: 'Individuellt'
      });
      dispatch(showDialogAction({
        title: "Du \xE4r anm\xE4ld till ".concat(compName, "."),
        icon: 'exclamation-sign',
        buttons: [{
          text: 'Okej'
        }]
      }));
    } catch (err) {
      logger.info("N\xE5got gick fel vid anm\xE4lan till t\xE4vlingen (id: ".concat(competition.id, "): ").concat(err));
      const {
        errorTitle,
        errorMessage
      } = processErrorCode(err);
      dispatch(showDialogAction({
        title: errorTitle,
        text: errorMessage,
        icon: 'exclamation-sign',
        type: 'error',
        buttons: [{
          text: 'Okej'
        }]
      }));
    }
  };
  const validateDocuments = () => {
    const notValid = Object.entries({
      compName,
      rulesDocumentId,
      competitionId: competition.id,
      policyPersonalData
    }).filter(_ref2 => {
      let [, v] = _ref2;
      return !v;
    }).map(_ref3 => {
      let [k] = _ref3;
      return k;
    });
    if (notValid.length) {
      const logMessage = "Missing data: ".concat(notValid.join(', '));
      logger.info(logMessage);
    }
  };
  const handleRegisterUser = () => {
    validateDocuments();
    dispatch(showDialogAction({
      title: "Bekr\xE4fta att du vill g\xE5 med i ".concat(compName),
      text: "Genom att g\xE5 med i ".concat(compName, " godk\xE4nner du <br/> <a target=\"_blank\" rel='noreferrer' href=\"/dokument/").concat(rulesDocumentId, "\" target=\"_blank\">regler och villkor f\xF6r ").concat(compName, "</a>\n              <br/><br/>Information g\xE4llande <a target=\"_blank\" rel='noreferrer' href=\"/dokument/").concat(policyPersonalData, "\" target=\"_blank\">behandling av personuppgifter</a>"),
      icon: 'exclamation-sign',
      buttons: [{
        text: 'Avbryt'
      }, {
        text: 'Gå med',
        callback: initPutParticipation
      }]
    }));
  };
  const handleRegisterTeam = () => history.push("/tavlingar/".concat(params.competitionName, "/skapa-lag"));
  return React.createElement("div", {
    className: "overview-hero-button-container dual-buttons"
  }, React.createElement(Button, {
    className: "button-150 qa-competition-overview-hero-register-user-button",
    onClick: preventDoubleClick(handleRegisterUser)
  }, "Individuellt"), React.createElement(Button, {
    className: "button-150 qa-competition-overview-hero-register-team-button",
    onClick: preventDoubleClick(handleRegisterTeam)
  }, "Lag"));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.Registration', Registration);

 })(window);